export const personalizations = [
  "Get regular alerts on projects that need your attention",
  "Get a summary of all active projects and timelines",
  "Easy chat for quick troubleshooting! "
];
